import { ItemOrList } from "types/common-types";
export type TabPropsType = {
    children?: ItemOrList<React.ReactNode> | undefined
    name?: string,
    title: string | React.ReactNode,
    reloadOnFocus?: boolean,
    hide?: any | (() => any),
}

const Tab = (props: TabPropsType) => {
    return (
        <div className="app-tabs_tab">
            {props.children}
        </div>
    );
}

export default Tab;
